import { useCallback } from 'react';
import { useFormatter } from 'js/hooks/useFormatter';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

export const useGetExportTransactions = () => {
    const formatter = useFormatter();
    const translate = useComponentTranslations();
    const { showProductForTransactions, showFeesForTransactions } = useComponentConfig();

    return useCallback(transactions => transactions.map(item => {
        const {
            fee, type, time, status, clientType, methodCode, methodName, localTransactionId,
            amount: { amount, currencyCode }, paymentAccountDetails: { additionalPaymentsFields, cardSuffix }
        } = item;

        let accountId;

        if (additionalPaymentsFields) {
            const accountIdField = additionalPaymentsFields.find(field => field.key === 'accountid');

            accountId = accountIdField ? accountIdField.value : additionalPaymentsFields[0].value;
        }

        return {
            [translate('column.title.date')]: formatter.getDateTimeShort(formatter.parseImsDate(time)),
            [translate('column.title.name')]: translate(`transaction.type.${type}`),
            [translate('column.title.amount')]: formatter.formatCurrency(amount, { currencyCode }),
            [translate('column.title.status')]: translate(`transaction.status.${status}`),
            [translate('column.title.method')]: methodName,
            [translate('column.title.account')]: accountId || cardSuffix || methodCode,
            [translate('transaction.id')]: localTransactionId,
            ...showProductForTransactions && { [translate('transaction.product')]: clientType },
            ...showFeesForTransactions && {
                [translate('transaction.fee')]: fee ? formatter.formatCurrency(fee.amount, { currencyCode: fee.currencyCode }) : ''
            }
        };
    }), [showProductForTransactions, showFeesForTransactions, translate, formatter]);
};
